/* Built In Imports*/
import { useEffect } from 'react';
/* External Imports */
import { Box, Heading, Text, useBreakpointValue } from '@chakra-ui/react';

import config from '@config';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Styles */
// import styles from './styles.module.css';
import styles from '@lb/Sections/aboutDevi/styles.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const AboutDeviSlide1 = ({ section }) => {
  useEffect(() => {
    gsap.to('.section1slide', {
      y: 100,
      opacity: 1,
      duration: 2,
      ease: 'power2.inOut',
    });
  }, []);

  return (
    <Box
      background={{
        base: `#000 url(${config.imgPath}/d/46272/1684473355-ib_secion1bg.jpg) no-repeat 67% 0px`,
        md: `#000 url(${config.imgPath}/d/46272/1684473355-ib_secion1bg.jpg) no-repeat center top`,
      }}
      bgSize="cover !important"
      className={styles.section1Bg}
      display="flex"
      justifyContent="center"
      position="relative"
      overflow="hidden"
    >
      <Box maxW={1300} width="100%" display="flex" position="relative">
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684475597-lb_eyes.png`}
          alt="eyes"
          className={`${styles.lb_eyes}`}
        />

        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684475388-lb_linga.png`}
          alt="linga"
          className={`${styles.lb_linga} lingaImg`}
        />
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684475581-lb_hands.png`}
          alt="hands"
          className={`${styles.lb_hands} handsImg`}
        />
        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475353-lb_mob_sadhguru.png`,
            xl: `${config.imgPath}/d/46272/1684475980-lb_sadhguru.png`,
          })}
          alt="lb_sadhguru"
          zIndex={{ base: 1, lg: 2 }}
          className={styles.lb_sadhguru}
        />
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684474079-lb_yantra.png`}
          alt="yantra"
          position="absolute"
          width={{ base: '200px', md: '213px', lg: '213px', xl: '313px' }}
          height={{ base: '60px', md: '70px', lg: '70px', xl: '120px' }}
          left={{ md: '50%', xl: '52%' }}
          top="0"
          transform="translate(-50%, 0px)"
          className={`section1Animate ${styles.imgNone}`}
        />
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684474013-lb_sun.png`}
          alt="lb_sun"
          position="absolute"
          width={{
            base: '102px',
            sm: '120px',
            md: '110px',
            xl: '200px',
          }}
          height={{
            base: '104px',
            sm: '127px',
            md: '117px',
            xl: '207px',
          }}
          left={{ base: '0', md: '0px', lg: '90px', xl: '0px' }}
          top={{
            base: '30px',
            sm: '60px',
            md: '40px',
            xl: '100px',
          }}
          className="section1Animate"
        />
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684475466-lb_moon.png`}
          alt="lb_moon"
          position="absolute"
          width={{
            base: '',
            md: '106px',
            lg: '136px',
            xl: '206px',
          }}
          height={{
            base: '',
            sm: '',
            md: '101px',
            lg: '131px',
            xl: '201px',
          }}
          right="0px"
          top={{ base: '140px', md: '30px', xl: '50px' }}
          className={`section1Animate ${styles.imgNone}`}
        />
        <Box
          display="flex"
          justifyContent="center"
          width="100%"
          alignItems="center"
          flexDirection={{ base: 'column', xl: 'row' }}
        >
          <Box
            zIndex="9"
            height={{ base: '100%', md: 'auto' }}
            width={{ base: '100%', xl: '390px' }}
            flexDir="column"
            justifyContent="center"
            position={{ base: 'absolute', md: 'static' }}
            pb={{ base: 7, md: 20, lg: 6, xl: 0 }}
            bgGradient={{
              base: 'linear-gradient(180deg, rgba(1, 1, 1, 0) 60%, #010101 100%)',
              xl: 'none',
            }}
            className={styles.lb_deviTextSection}
          >
            <Box
              px={{ base: 4, lg: '110px', xl: 6 }}
              w={{
                base: '12rem',
                sm: '14rem',
                md: '18rem',
                lg: '30rem',
                xl: '25rem',
              }}
            >
              <Text
                color="#FAEFE7"
                fontSize={{ base: '16px', md: '16px', xl: '24px' }}
                pb={3}
              >
                {section?.sectionContent?.[1]?.text}
              </Text>
              <Heading
                as="H1"
                color="primary.light"
                fontSize={{ base: '64px', md: '100px', xl: '150px' }}
                lineHeight={{ base: '60px', md: '80px', xl: '125px' }}
                fontFamily="'FedraSerifDisplay'"
                textTransform="uppercase"
              >
                {section?.sectionContent?.[0]?.text}
              </Heading>
              <Text
                color="#FAEFE7"
                fontSize={{ base: '14px', md: '18px', xl: '24px' }}
              >
                {' '}
                {section?.sectionContent?.[2]?.text}
              </Text>
            </Box>
          </Box>
          <Box
            width={{ base: '0', md: '100%', xl: '910px' }}
            bg={{ base: '#000', xl: 'none' }}
            position="relative"
            zIndex={3}
            px={{ base: '', md: '', lg: '100px' }}
            height="100%"
            pb={{ base: '4rem', xl: 0 }}
          >
            <LazyLoadImageComponent
              src={useBreakpointValue({
                base: `/assets/images/devi_img/lb_sadhguru_img1.png`,
                lg: `/assets/images/devi_img/lb_sadhguru_img1.png`,
              })}
              alt="sadhguru"
              className={styles.sadhguruImg1}
            />
            <LazyLoadImageComponent
              src={useBreakpointValue({
                base: `/assets/images/devi_img/lb_sadhguru_img2.png`,
                lg: `/assets/images/devi_img/lb_sadhguru_img2.png`,
              })}
              alt="lb_sadhguru_img2"
              className={styles.sadhguruImg2}
            />
          </Box>
        </Box>
      </Box>
      <Box
        pos="absolute"
        bottom="0px"
        width="100%"
        height={{ base: 0, xl: '0rem' }}
        bgImg={{
          base: 'linear-gradient(180deg, rgba(1, 1, 1, 0) 0%, #010101 100%)',
          md: 'linear-gradient(180deg, rgba(1, 1, 1, 0) 0%, #010101 100%)',
        }}
        zIndex="9"
      ></Box>
    </Box>
  );
};
export default AboutDeviSlide1;
